<template>
  <SettingsPageFull>
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'tasks']" size="2x" />
        <span class="text-2xl font-bold capitalize-first">
          {{ $t('navigation.content_task_title') }}
        </span>
      </div>
    </template>

    <template #cta>
      <BaseButton
        color="primary"
        icon="plus"
        :title="$t('button.add_new_f', { var: $t('global.task') })"
        @click="this.$router.push({ name: 'settings_create_tasks_route' })"
      />
    </template>

    <template #body>
      <BaseContentTable
        v-if="metadata.columns || loading"
        :columns="metadata.columns ?? []"
        :loading="loading"
        :modelList="tasksList"
        :search="true"
        @rowClick="redirectToModelPage"
        @refreshClick="withLoading(fetchTasksList())"
        @deleteModel="deleteTask"
        :isHoverable="true"
      />
    </template>
  </SettingsPageFull>
</template>

<script>
import loadingMixin from '@u/mixins/loading.mixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheTaskIndexPage',
  mixins: [loadingMixin],
  computed: {
    ...mapGetters({
      tasksList: 'task/getTasksList',
      metadata: 'task/getTaskMetadata',
      errors: 'auth/getErrors'
    })
  },
  methods: {
    ...mapActions({
      fetchTasksList: 'task/fetchTasksList',
      deleteTaskById: 'task/deleteTaskById',
      undoDeleteTaskById: 'task/undoDeleteTaskById'
    }),
    redirectToModelPage(id) {
      this.$router.push({
        name: 'settings_edit_tasks_route',
        params: { id: id }
      })
    },
    deleteTask(id) {
      this.deleteTaskById({
        id: id
      }).then(() => {
        this.$h.toastAction(
          'delete',
          this.$t('toasts.deleted_f', { var: this.$t('attributes.task') }),
          null,
          [
            {
              title: this.$t('button.cancel'),
              class: 'text-red-700',
              action: () => this.undoDeleteTask(id)
            }
          ]
        )
      })
    },
    undoDeleteTask(id) {
      this.undoDeleteTaskById({
        id: id
      }).then(() => {
        this.$h.toastSuccess(
          this.$t('toasts.reseted_f', { var: this.$t('attributes.task') })
        )
      })
    }
  },
  async mounted() {
    await this.withLoading(this.fetchTasksList())
  }
}
</script>
